export default __webpack_public_path__ + "static/media/landing-left.9f8ae935.jpg";